import Nav from "../main/navBar";

const Projects = () => {
  function Project(props) {
    return (
      <div className="project">
        <img
          src={require("../../assets/img/projects/projet0" +
            props.number +
            ".png")}
          alt=""
        />
        <div className="project-info-card">
          <article className="project-info">
            <h3>{props.title}</h3>
            <p className="project-description">{props.desc}</p>
            <p className="project-tag">{props.tag}</p>
          </article>
          {/* <div className="project-icon">
            <i class={props.icon}></i>
          </div> */}
        </div>
      </div>
    );
  }

  return (
    <section className="projects-section" id="projects">
      <Nav></Nav>
      <article>
        <Project
          number="1"
          title="JPPCompta"
          desc="Expertise fiable pour une gestion toujours sereine."
          tag="React Native"
        ></Project>
        <Project
          number="2"
          title="Le 393"
          desc="Une cuisine maison, savoureuse et toujours conviviale."
          tag="React Native"
        ></Project>
        <Project
          number="3"
          title="CookinCrew"
          desc="Partagez vos recettes, savourez la passion culinaire."
          tag="PHP mvc"
        ></Project>
        <Project
          number="4"
          title="Lantre"
          desc="Lieu incontournable pour vibrer au rythme techno."
          tag="React Native"
        ></Project>
        <Project
          number="5"
          title="Portal"
          desc="Centralisez vos applis, dynamisez votre productivité."
          tag="PHP"
        ></Project>
        <Project
          number="6"
          title="Portfolio"
          desc="Créateur d'émotions digitales, je façonne vos idées en expériences immersives."
          tag="React Native"
        ></Project>
      </article>
    </section>
  );
};

export default Projects;
